const TRUSTED_HOST = 'sytex.io';
const TRUSTED_HOST_SUFFIX = '.sytex.io';

/**
 * Returns true only when `value` is an absolute http(s) URL whose host is
 * `sytex.io` or any of its subdomains (`*.sytex.io`). Every Sytex property
 * across all environments (dev, prod and EU prod) lives under `sytex.io`, so
 * this is the complete trust boundary for post-login redirect targets.
 *
 * Used to prevent open redirects: relative URLs, protocol-relative URLs
 * (`//evil.com`), non-http(s) schemes (`javascript:`, `data:`) and any
 * external host are rejected. The WHATWG `URL` parser also neutralises the
 * classic bypasses, e.g. `https://app.sytex.io@evil.com` resolves to host
 * `evil.com`, and `https://sytex.io.evil.com` fails the suffix check.
 */
export function isTrustedRedirectUrl(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }

  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    return false;
  }

  const host = url.hostname.toLowerCase();
  return host === TRUSTED_HOST || host.endsWith(TRUSTED_HOST_SUFFIX);
}
